module.exports = __webpack_public_path__ + "img/next.dfaff7f8.svg";